(ns ycweb.app.website.school.quiz.results
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc module-quiz-score < rum/reactive [app-atom]
  (let [state-atom (cmn/action-cursor app-atom)
        course (cmn/curact state-atom [:course])
        module-atom (rum/cursor-in state-atom [:module])
        module (rum/react module-atom)
        quiz-atom (rum/cursor-in module-atom [:module/quiz])
        quiz (rum/react quiz-atom)]
    (list
      [:main
       {:id "main-content" :class (u/bem :header-banner [:has-avatar] :u-bg-oil)}
       [:div.header-banner__text-wrapper
        [:div.header-banner__text.u-text-white
         [:div.header-banner__avatar
          (web-common/lazy-image app-atom
            (:doc/public-id (:ent/image (:course/host course)))
            {:class ["avatar  yc-simple-image  yc-simple-image--full  yc-simple-image--border  yc-simple-image--shadow"]}
            {:w 140
             :h 140
             :q "auto"})]
         [:h1.header-banner__title
          (:ent/display-name course)
          [:span.header-banner__subtitle "Presented by " (:ent/display-name (:course/host course))]]]]
       [:div.header-banner__image-wrapper
        (web-common/lazy-image app-atom
          (:doc/public-id (:ent/image course))
          {:class ["header-banner__image"]}
          {:w 1920
           :mw 490
           :dpr 2
           :q "auto"
           :alt (:ent/display-name (:course/host course))})]
       (toaster/loading-overlay app-atom :web.cooking-school/course-overview)]
      [:div
       {:class (u/bem :yc-page-content [:medium])}
       (cond
         (:module/course-completed? module)
         [:div.u-text-center
          {:class (u/bem :yc-section [:large])}
          [:div.u-block-center.u-max-width-720
           (headings/heading
             (str "Nicely done! You've just completed " (:module/course-title module))
             {:type :h1
              :size :large
              :center true})

           [:p
            {:class (u/bem :yc-paragraph [:large])}
            [:b "Quiz score: "]
            [:span.text-status--success (:quiz/score quiz) "%"]]

           [:div.course-progress-tracker.u-margin-top-30
            {:title "100% complete"}
            [:div
             {:class (u/bem :course-progress-tracker__bar [:complete])
              :style {:width "100%"}}
             [:small.hidden-from-view "100% complete"]]]

           [:p.yc-paragraph
            "We really hope that you've been inspired and that you now have the confidence to give it a go on your own.
            Everything you've watched and learnt in this course is available in the course notes and recipes,
            and you can revisit these at any time. Now, go ahead and download the fancy certificate below, you clever cook."]

           [:div.u-block-center.u-max-width-480.flex-grid-group
            [:div.flex-grid-block.flex-grid-block--ml-1-2
             [:div.flex-grid-content
              (buttons/button-web "Download Certificate"
                {:href (str "/api/school/certificate/" (str (:module/user-course-uuid module)) ".pdf")
                 :style :primary
                 :size :default
                 :full true
                 :target "_blank"})]]
            [:div.flex-grid-block.flex-grid-block--ml-1-2
             [:div.flex-grid-content
              (buttons/button-web "Return to Course"
                (merge
                  (urlstate/href-props app-atom "cooking-school" "mycourseview" {:uuid (:module/course-uuid module)})
                  {:style :secondary
                   :size :default
                   :full true}))]]]]]

         :else
         [:div
          {:class (u/bem :yc-section [:standard])}
          [:div.u-block-center.u-max-width-720
           [:ul.breadcrumbs.group
            [:li.breadcrumbs__item
             [:a.breadcrumb__link
              (urlstate/href-props app-atom "cooking-school" "my-courses" {})
              "My Courses"]]
            [:li.breadcrumbs__item
             [:a.breadcrumb__link
              (urlstate/href-props app-atom "cooking-school" "mycourseview" {:uuid (:module/course-uuid module)})
              (:module/course-title module)]]
            [:li
             {:class (u/bem :breadcrumbs__item [:always-show])}
             [:a.breadcrumb__link
              (urlstate/href-props app-atom "cooking-school" "moduleview" {:uuid (:module/user-module-uuid module)})
              (str "Lesson " (:module/position module))
              [:span.clip-text.unclip-text--m ": " (:ent/display-name module)]]]
            [:li.breadcrumbs__item
             [:span.breadcrumb__current-text "Quiz"]]]
           (headings/heading
             ["Quiz Score: "
              (if (> (:quiz/score quiz) 80)
                [:span.text-status--success (:quiz/score quiz) "%"]
                [:span.text-status--error (:quiz/score quiz) "%"])]
             {:type :h1
              :size :large})
           (when (<= (:quiz/score quiz) 80)
             [:p
              {:class (u/bem :yc-paragraph [:large])}
              "You need a score of 80% or higher to complete this step."])
           [:div.u-max-width-480
            [:div
             {:class (u/bem :flex-grid-group [:flush :align-left])}
             [:div
              {:class (u/bem :flex-grid-block [:ml-1-2])}
              [:div.flex-grid-content

               (buttons/button-web "Correct Your Answers"
                 (merge
                   (urlstate/href-props app-atom "cooking-school" "quizview" {:uuid (:ent/uuid quiz)})
                   {:style :primary
                    :size :default
                    :full true}))]]

             (when-not (empty? (:module/next module))
               [:div
                {:class (u/bem :flex-grid-block [:ml-1-2])}
                [:div.flex-grid-content
                 (buttons/button-web "Skip to Next Lesson"
                   (merge
                     (urlstate/href-props app-atom "cooking-school" "moduleview" {:uuid (:module/user-module-uuid (:module/next module))})
                     {:style :secondary
                      :size :default
                      :full true}))]])]
            [:p
             {:class (u/bem :yc-paragraph [:small] :u-margin-top-20)}
             "Remember, you can revisit this lesson and view its course notes any time you like."]]]])

       (when-not (empty? (:module/next module))
         [:div
          {:class (u/bem :yc-section [:large])}
          [:div.u-block-center.u-max-width-720
           (headings/heading (:ent/display-name (:module/next module))
             {:type :h2
              :size :medium
              :pretext "Up Next"})
           [:div.yc-simple-text
            {:dangerouslySetInnerHTML {:__html (:module/outline (:module/next module))}}]
           (buttons/button-web "Next Lesson"
             (merge
               (urlstate/href-props app-atom "cooking-school" "moduleview" {:uuid (:module/user-module-uuid (:module/next module))})
               {:style :secondary
                :size :default
                :full true}))]])
       (toaster/loading-overlay app-atom :web.cooking-school/quizscore)])))

(defmethod flow/render-screen :web.cooking-school/quizscore [app-atom _]
  (website/screen-wrapper app-atom
    (module-quiz-score app-atom)
    {:pagetype :school}))

(defmethod t/transition-open :web.cooking-school/quizscore [app-atom _ params]
  (swap! (cmn/action-cursor app-atom) assoc :quiz-uuid (:uuid params))
  (toaster/open-overlay app-atom :web.cooking-school/quizscore)
  (comms/ajax-get :web.cooking-school/quizscore {:ent/uuid (:uuid params)}))

(defmethod comms/receive :web.cooking-school/quizscore [app-atom e]
  (toaster/close-overlay app-atom :web.cooking-school/quizscore)

  (swap!
    (cmn/action-cursor app-atom) assoc
    :module (:module e)
    :course (:course e)))



